import React, { Component } from 'react';
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../../store';
import AutofacturacionTicketList from './components/AutofacturacionTicketList';
import AutofacturacionItemActions from './components/AutofacturacionItemActions';
import AutofacturacionTicketFilter from './components/AutofacturacionTicketFilter';
import AutofacturacionTicketsSearch from './components/AutofacturacionTicketsSearch';
import AutofacturacionTicketsListActions from './components/AutofacturacionTicketsListActions';

class AutofacturacionTickets extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Tickets');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/modulos/autofacturacion/tickets/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  };

  handleOnKeywordChange = (search) => {
    const { keyword, field } = search;
    const { pagination } = this.props;

    const newSearch = {
      ...pagination,
      field,
      search: keyword,
    };

    this.props.paginate(newSearch);
  };

  handleOnSuccess = () => {
    this.handleOnRowSelectionChange({
      selectedRowKeys: [],
      selectedRows: [],
    });

    this.props.paginate();
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to, search } = this.props.pagination;

    return (
      <>
        <Row>
          <Col
            sm="auto"
            md="8"
            className="mb-2"
          >
            {selectedRowKeys.length === 0 && (
              <AutofacturacionTicketsSearch
                from={from}
                to={to}
                search={search}
                onDateChange={this.handleOnDateChange}
                onKeywordChange={this.handleOnKeywordChange}
              />
            )}

            {selectedRowKeys.length > 0 && (
              <AutofacturacionItemActions
                selectedRows={selectedRows}
                selectedRowKeys={selectedRowKeys}
                onSuccess={this.handleOnSuccess}
              />
            )}
          </Col>
          <Col
            sm="auto"
            md="4"
            className="text-right pb-2"
          >
            <AutofacturacionTicketsListActions
              from={from}
              to={to}
              selectedRowKeys={selectedRowKeys}
              selectedRows={selectedRows}
              alignRight={false}
            />
          </Col>
        </Row>

        {selectedRowKeys.length === 0 && <AutofacturacionTicketFilter />}

        {Guardian.allows('autofacturacion.listar.tickets') && (
          <AutofacturacionTicketList
            onRowClick={this.handleOnRowClick}
            selectedRowKeys={selectedRowKeys}
            selectedRows={selectedRows}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return store.modulo.autofacturacion.tickets;
};

const mapActions = (actions) => {
  return actions.modulo.autofacturacion.tickets;
};

export default connect(useStore, mapState, mapActions)(AutofacturacionTickets);
